module.exports = __webpack_public_path__ + "media/apps/app-store-fr-d59010fc.png";